import { motion } from "framer-motion";

const floatAnimation = {
  initial: { opacity: 0, y: 10 },
  animate: {
    opacity: 1,
    y: [0, -12, 0],
  },
  transition: {
    duration: 8,
    repeat: Infinity,
    ease: "easeInOut",
  },
};

const PartnersOrbit = () => {
  return (
    <section
      id="Partners"
      className="relative bg-white py-24 md:py-32 flex items-center justify-center overflow-hidden"
    >
      {/* Floating avatars */}
      <motion.div
        className="absolute left-[30px] top-[50px] md:left-[100px] md:top-[150px] lg:left-[200px] lg:top-[150px] flex flex-col items-center gap-2"
        {...floatAnimation}
        transition={{ ...floatAnimation.transition, delay: 0 }}
      >
        {/* <div className="w-16 h-16 rounded-full bg-gray-200 shadow-md" /> */}
        <span className="px-3 py-1 text-xs text-white rounded-full bg-pink-500">
          Mindef
        </span>
      </motion.div>

      <motion.div
        className="absolute right-[30px] top-[50px] md:right-[100px] md:top-[150px] lg:right-[200px] lg:top-[150px] flex flex-col items-center gap-2"
        {...floatAnimation}
        transition={{ ...floatAnimation.transition, delay: 0.4 }}
      >
        {/* <div className="w-16 h-16 rounded-full bg-gray-200 shadow-md" /> */}
        <span className="px-3 py-1 text-xs text-white rounded-full bg-sky-500">
          ASME
        </span>
      </motion.div>

      <motion.div
        className="absolute right-[150px] top-[30px] md:right-[180px] md:top-[80px] lg:right-[300px] lg:bottom-[150px] flex flex-col items-center gap-2"
        {...floatAnimation}
        transition={{ ...floatAnimation.transition, delay: 0.8 }}
      >
        {/* <div className="w-16 h-16 rounded-full bg-gray-200 shadow-md" /> */}
        <span className="px-3 py-1 text-xs text-white rounded-full bg-orange-500">
          NUHS
        </span>
      </motion.div>

      <motion.div
        className="absolute right-[30px] bottom-[120px] md:right-[250px] md:bottom-[100px] lg:right-[300px] lg:bottom-[100px] flex flex-col items-center gap-2"
        {...floatAnimation}
        transition={{ ...floatAnimation.transition, delay: 1.2 }}
      >
        {/* <div className="w-16 h-16 rounded-full bg-gray-200 shadow-md" /> */}
        <span className="px-3 py-1 text-xs text-white rounded-full bg-green-500">
          ISCA
        </span>
      </motion.div>

      <motion.div
        className="absolute left-[20px] bottom-[50px] md:left-[200px] md:bottom-[100px] lg:left-[300px] lg:bottom-[100px] flex flex-col items-center gap-2"
        {...floatAnimation}
        transition={{ ...floatAnimation.transition, delay: 1.6 }}
      >
        {/* <div className="w-16 h-16 rounded-full bg-gray-200 shadow-md" /> */}
        <span className="px-3 py-1 text-xs text-white rounded-full bg-amber-400">
          Standard Chartered
        </span>
      </motion.div>

      <motion.div
        className="absolute left-[260px] bottom-[50px] md:left-[150px] md:bottom-[150px] lg:left-[150px] lg:bottom-[250px] flex flex-col items-center gap-2"
        {...floatAnimation}
        transition={{ ...floatAnimation.transition, delay: 1.6 }}
      >
        {/* <div className="w-16 h-16 rounded-full bg-gray-200 shadow-md" /> */}
        <span className="px-3 py-1 text-xs text-white rounded-full bg-red-400">
          Knight Frank
        </span>
      </motion.div>

      <motion.div
        className="absolute left-[160px] bottom-[110px] md:left-[330px] md:bottom-[140px] lg:left-[150px] lg:bottom-[150px] flex flex-col items-center gap-2"
        {...floatAnimation}
        transition={{ ...floatAnimation.transition, delay: 1.6 }}
      >
        {/* <div className="w-16 h-16 rounded-full bg-gray-200 shadow-md" /> */}
        <span className="px-3 py-1 text-xs text-white rounded-full bg-slate-800">
          People's Association
        </span>
      </motion.div>

      <motion.div
        className="absolute left-[160px] bottom-[70px] md:left-[490px] md:bottom-[80px] lg:left-[150px] lg:bottom-[70px] flex flex-col items-center gap-2"
        {...floatAnimation}
        transition={{ ...floatAnimation.transition, delay: 1.6 }}
      >
        {/* <div className="w-16 h-16 rounded-full bg-gray-200 shadow-md" /> */}
        <span className="px-3 py-1 text-xs text-white rounded-full bg-blue-400">
          LNX Global
        </span>
      </motion.div>

      {/* Center content */}
      {/* Center content */}
<div className="text-center max-w-xl p-6">
  <p className="text-xs tracking-wide text-gray-500 mb-4">
    Handshakes Made Simple
  </p>

  <h1 className="text-4xl md:text-5xl font-semibold text-gray-900 leading-tight mb-6">
    Ecosystem of Clients & Strategic Partners<br /> 
  </h1>

  <p className="text-sm text-gray-600 mb-8">
     Powered by institutional partnerships, NextLoop's Ecosystem has reached decision-makers across 150+ organisations
  </p>


</div>

    </section>
  );
};

export default PartnersOrbit;
